import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDqDfYZsd6KNvZ-jIvyRzVr_N9gj2PNuCM",
  authDomain: "startupcycu.firebaseapp.com",
  databaseURL: "https://startupcycu.firebaseio.com",
  projectId: "startupcycu",
  storageBucket: "startupcycu.appspot.com",
  messagingSenderId: "1063828465652",
  appId: "1:1063828465652:web:310983cde7c9153891bba1",
  measurementId: "G-032D9Z3KNB"
};
  // Initialize Firebase
firebase.initializeApp(firebaseConfig);

export {firebase}
